import { createSelector } from 'reselect'
import { ApplicantAvailability } from '../types/applicantAvailability'
import { StateInterface } from '../types/states'
import { futureAvailabiliy } from '../utils/applications'
import { compareStartDates } from '../utils/sorting'

const selectAvailabilityDomain = (state: StateInterface) => state.availabilities

const selectAvailabilities = createSelector(
  selectAvailabilityDomain,
  (availabilities) => availabilities.availabilities
)

const selectIsAvailabilityCreating = createSelector(
  selectAvailabilityDomain,
  (availabilities) => availabilities.isCreating
)
const selectIsAvailabilityDeleting = createSelector(
  selectAvailabilityDomain,
  (availabilities) => availabilities.isDeleting
)

const selectAvailabilitiesByApplicant = createSelector(
  selectAvailabilityDomain,
  (availabilities) =>
    availabilities.availabilitiesByApplicants.sort(compareStartDates)
)
const selectFutureAvailabilitiesByApplicant = createSelector(
  selectAvailabilityDomain,
  (availabilities) =>
    availabilities.availabilitiesByApplicants.filter(futureAvailabiliy)
)

const selectAvailabilitiesByApartment = (apartmentId: string) =>
  createSelector(selectAvailabilities, (availabilities) => {
    const times: any[] = availabilities
    return availabilities
      ? (times.filter((time) => time.apartmentId === apartmentId) as any[]) ||
          []
      : ([] as any[])
  })

const selectAvailabilitiesByApplicationIds = (
  availabilities: ApplicantAvailability[],
  applicationIds: string[]
) =>
  availabilities
    .filter((availability) =>
      applicationIds.includes(availability.applicationId)
    )
    .sort(compareStartDates)

// const selectAvailabilitiesByApplicationIds = (
//   availabilities: ApplicantAvailability[],
//   applicationId: string
// ) =>
//   availabilities
//     .filter(availability => availability.applicationId === applicationId)
//     .sort(compareStartDates)

export {
  selectAvailabilities,
  selectAvailabilitiesByApplicant,
  selectFutureAvailabilitiesByApplicant,
  selectAvailabilitiesByApartment,
  selectIsAvailabilityCreating,
  selectIsAvailabilityDeleting,
  selectAvailabilitiesByApplicationIds
}
